import { ReactComponent as FlagIcon } from "./svg/nl-flag.svg";
import "../flag-icon.scss";

export const NLFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
